export default function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isObject.js
// module id = PVZL
// module chunks = 0